import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mongoUserId, setMongoUserId] = useState(null);

  useEffect(() => {
    // Check for stored auth data on mount
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");
    const mongoId = localStorage.getItem("mongoID");

    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    }

    if (mongoId) {
      setMongoUserId(mongoId);
    }

    setLoading(false);
  }, []);

  const login = async (authData) => {
    // Store the token and user data
    localStorage.setItem("token", authData.token);
    localStorage.setItem("user", JSON.stringify(authData.user));
    setUser(authData.user);
  };

  const mongoLogin = async (userId) => {
    localStorage.setItem("mongoID", userId);
    setMongoUserId(userId);
  };

  const mongoLogout = async () => {
    localStorage.removeItem("mongoID");
    setMongoUserId(null);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("mongoID");
    setUser(null);
    setMongoUserId(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
    mongoUserId,
    mongoLogin,
    mongoLogout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default AuthContext;
